module.exports = __webpack_public_path__ + "img/37-image-1-1@2x.c965849a.png";